export default __webpack_public_path__ + "static/aadhaarVerification-6809c893d81f106d1009ac9fa139d5d4.webm";